import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  gap: 36px;
  margin-top: 32px;
  background-color: ${({ theme }) => theme.colors.grey.black};
  padding: 28px;
  border-radius: 16px;
  position: relative;
`;

export const WrapImg = styled.div`
  width: 100%;
  max-width: 180px;
  height: fit-content;
  position: relative;
  top: -60px;

  .perfil {
    width: 180px;
    height: 180px;
    object-fit: cover;
    border-radius: 100%;
  }

  .verification {
    width: 100%;
    max-width: 48px;
    position: absolute;
    bottom: 0px;
    right: 0px;
  }
`;

export const Group = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 36px;
`;

export const Top = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  > div {
    display: flex;
    flex-direction: column;
    gap: 8px;

    div {
      display: flex;
      align-items: center;
      gap: 4px;

      svg {
        color: ${({ theme }) => theme.colors.grey[500]};
      }

      p {
        margin-bottom: -2px;
      }
    }
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 20px;
    background-color: rgba(255, 255, 255, 0.4);
    border: 2px solid ${({ theme }) => theme.colors.grey.white};
    border-radius: 32px;

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }
  }
`;
